import { render, staticRenderFns } from "./manageNnitAdd-edit.vue?vue&type=template&id=05ad94bf&scoped=true"
import script from "./manageNnitAdd-edit.vue?vue&type=script&lang=js"
export * from "./manageNnitAdd-edit.vue?vue&type=script&lang=js"
import style0 from "./manageNnitAdd-edit.vue?vue&type=style&index=0&id=05ad94bf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ad94bf",
  null
  
)

export default component.exports